var FE = {
	location: window.location,

    Booking: {
        bookingServiceBaseUrl: 'https://webtermin.medatixx.de/#/',
        bookingId: null,
        authKey: 'hno-2023',
        init: function () {
            this.addModal();
            const bookingSelect = document.querySelector('.booking-select');
            const bookingAuth = document.querySelector('.booking-auth');
            document.querySelector('.contact-date').addEventListener('click', function (e) {
                e.preventDefault();
                if (!bookingSelect.classList.contains('show')) {
                    bookingSelect.classList.add('show');
                } else {
                    bookingSelect.classList.remove('show');
                    bookingAuth.classList.remove('show');
                }

            });
            document.querySelector('#booking-auth-form').addEventListener('submit', function (e) {
                e.preventDefault();
                FE.Booking.checkAuth(e);
            });
            document.querySelector('[data-booking-id]').addEventListener('click', function (e) {
                FE.Booking.bookingId = e.currentTarget.dataset.bookingId;
                bookingAuth.classList.add('show');
            });
        },
        checkAuth: function (e) {
            if ( e.target.elements.password.value === FE.Booking.authKey ) {
                FE.Booking.loadBooking();
                document.querySelector('.booking-auth').classList.remove('show');
                document.querySelector('.booking-select').classList.remove('show');
            } else {
                alert('Das Passwort ist leider nicht gültig!');
            }
        },
        loadBooking: function () {
            const modal = document.querySelector('#booking-widget');
            const iframe = document.createElement('iframe');
            //console.log(FE.Booking.bookingServiceBaseUrl + FE.Booking.bookingId);
            iframe.src = FE.Booking.bookingServiceBaseUrl + FE.Booking.bookingId;
            iframe.id = 'terminbuchung-iframe';
            iframe.classList.add('booking-widget-iframe');
            iframe.addEventListener('load', function (e) {
                if(!e.currentTarget.classList.contains('show')) {
                    // show modal when iframe has been loaded
                    modal.classList.add('show');
                    e.currentTarget.classList.add('show');
                } else {
                    // booking widget closed
                    modal.classList.remove('show');
                    // remove modal iframe
                    modal.removeChild(modal.firstChild);
                    e.currentTarget.classList.remove('show');
                }
            });
            //console.log(e.currentTarget);

            modal.appendChild(iframe);
        },
        addModal: function () {
            const modal = document.createElement('div');
            modal.id = 'booking-widget';
            modal.classList.add('booking-widget');
            modal.classList.add('terminbuchung-overlay');
            document.body.append(modal);
        }
    },

	MobileMenu: {
		init: function() {
            FE.MobileMenu.indicateSubMenu();
			$('.burger-icon-area').click(function() {
                $('.nav-main').slideToggle();
                $(this).find('.burger-icon').toggleClass('active');
            });
		},
        indicateSubMenu: function() {
            $('.nav-main > ul > li').each(function() {
                if ( $(this).find('ul').length ) {
                    $(this).prepend('<span></span>');
                }
                $(this).find('span').click(function() {
                    $(this).siblings('ul').slideToggle();
                    $(this).parent().toggleClass('active');
                });
            });
        }
	},

    HeroImageSlider: {
        init: function() {
            $('.ce-hero-image').slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                asNavFor: '.slider-for',
                dots: false,
                arrows: false,
                infinite: true,
                speed: 1000,
                fade: false,
                slide: 'figure',
                cssEase: 'linear',
                autoplay: true,
                autoplaySpeed: 5000,
                centerMode: false,
                focusOnSelect: false
            });
        }
    },

    Accordion: {
	    init: function () {
	        if ( $('.ce-accordions').hasClass('ce-layout-0') ) {
	            FE.Accordion.make2Cols();
            }
            $('.ce-accordions-group header').each(function () {
               $(this).prepend('<span></span>');
            });
            $('.ce-accordions-group header').on('click', function () {
                $(this).next().slideToggle();
                $(this).toggleClass('active');
            });
        },
        make2Cols: function () {
            $('.ce-accordions-group').append('<div class="ce-accordions-group-col"></div><div class="ce-accordions-group-col"></div>');
            var accordionItemsSplit = Math.ceil( $('.ce-accordions-group .ce-text-simple').length / 2 );
            $('.ce-accordions-group .ce-text-simple').slice(0, accordionItemsSplit).appendTo( $('.ce-accordions-group-col').first() );
            // move rest into second col
            $('.ce-accordions-group > .ce-text-simple').appendTo( $('.ce-accordions-group-col').last() );
        }
    },

    DoctorOverview: {
	    init: function () {
            FE.DoctorOverview.buildTabMenu();
        },
        buildTabMenu: function () {
	        $('.ce-doctor-overview').prepend('<ul class="ce-doctor-overview-tab-menu"></ul>');
            $('.ce-doctor-item').each(function () {
                $('.ce-doctor-overview-tab-menu').append('<li><a href="#">' + $(this).find('h3').text() + '</a></li>');
            });
            $('.ce-doctor-overview-tab-menu li').first().find('a').addClass('active');

            $('.ce-doctor-overview-tab-menu li a').on('click', function (e) {
                e.preventDefault();
                $('.ce-doctor-overview-tab-menu li a').removeClass('active');
                $(this).addClass('active');
                $('.ce-doctor-group .ce-doctor-item').hide();
                $('.ce-doctor-group .ce-doctor-item').eq( $(this).parent().index() ).fadeIn();
            });
        }
    },

    DatePicker: {
	    init: function () {
	        // link Datenschutzerklärung
            this.linkPrivacyPolicy();

            $("#terminService-260-datepicker-1").datepicker({
                dateFormat: "dd.mm.yy",
                minDate: new Date(),
            }).on("keydown", function(e) {
                // By using "backspace" or "delete", you can clear the datepicker again.
                if(e.keyCode == 8 || e.keyCode == 46) {
                    e.preventDefault();
                    $.datepicker._clearDate(this);
                }
            });
            $('#terminService-260-datepicker-1').attr('placeholder', 'Format Beispiel: 31.03.2021');
            $('#terminService-260-datepicker-2').attr('placeholder', 'Format Beispiel: 15.06.1980');
            $("#terminService-260-datepicker-2").datepicker({
                dateFormat: "dd.mm.yy",
                minDate: new Date(1900, 0, 1),
                maxDate: new Date(),
                yearRange: "c-100:c",
                changeYear: true
            }).on("keydown", function(e) {
                // By using "backspace" or "delete", you can clear the datepicker again.
                if(e.keyCode == 8 || e.keyCode == 46) {
                    e.preventDefault();
                    $.datepicker._clearDate(this);
                }
            });
            FE.DatePicker.adjustTimeLabels();
            FE.DatePicker.removeNonOfficeHours();
            FE.DatePicker.set15MinInterval();
        },
        adjustTimeLabels: function () {
            $('label[for="terminService-datepicker-1-time"]').text('Stunde');
            $('label[for="terminService-datepicker-1-time-minute"]').text('Minuten');
        },
        removeNonOfficeHours: function () {
            $('#terminService-260-datepicker-1-time option').each(function () {
                if (  parseInt($(this).val()) < 8 || parseInt($(this).val()) > 18 ) {
                    $(this).remove();
                }
            });
        },
        set15MinInterval: function () {
            $('#terminService-260-datepicker-1-time-minute-minute option').each(function () {
                if (  parseInt($(this).val()) % 15 != 0 ) {
                    $(this).remove();
                }
            });
        },
        linkPrivacyPolicy: function () {
            var privacyPolicyLabel =  document.querySelector('label[for="terminService-260-checkbox-1"]');
            var privacyPolicyLink = '<a href="/datenschutz/" target="_blank">Datenschutzerklärung</a>';
            privacyPolicyLabel.innerHTML = privacyPolicyLabel.innerHTML.replace('Datenschutzerklärung', privacyPolicyLink);
        }
    },

    ContactWidget: {
	    init: function () {
            $('.contact-widget-icon').on('click', function () {
                if ( $(this).hasClass('active') ) {
                    $(this).removeClass('active');
                    $(this).parent().animate({
                        right: '-220px'
                    }, 700);
                } else {
                    $(this).addClass('active');
                    $(this).parent().animate({
                        right: 0
                    }, 700);
                }
            });
        }
    },

    DataProtectionFormLink: {
	    init: function () {
	        var labelElement = $('#terminService > div.form-group span').first();
	        var labelText = labelElement.text();
	        //console.log(labelText);
	        var labelHtml = labelText.replace('Datenschutzerklärung', '<a href="/datenschutz/" target="_blank">Datenschutzerklärung</a>');
            labelElement.html(labelHtml);
        }
    },

    PageInfoBar: {
        init: function () {
            const pageInfoBar = document.querySelector('.page-info-bar');
            //const pageInfoBarCloseBtn = document.querySelector('button.close-info-bar');

            setTimeout(function () {
                pageInfoBar.classList.add('show');
            }, 500);

            /*
            pageInfoBarCloseBtn.addEventListener('click', function () {
                pageInfoBar.classList.remove('show');
            });
             */
        }
    },

    PageInfoDialog: {
        init: function () {
            const dialog = document.querySelector("dialog");
            const closeButton = document.querySelector(".close-info-dialog");

            dialog.showModal();

            closeButton.addEventListener("click", () => {
                dialog.close();
            });

        }
    }

};

// init custom functions
(function ($, window, document, undefined) {

	$(function () {
        //FE.Lightbox.init();
		FE.MobileMenu.init();
        //FE.ContactWidget.init();
        if ( $('.ce-hero-image figure').length > 1 ) {
            FE.HeroImageSlider.init();
        }
        if ( $('.ce-accordions-group').length ) {
            FE.Accordion.init();
        }
        if ( $('.ce-doctor-overview').length ) {
            FE.DoctorOverview.init();
        }
        if ( $('#terminService-260-datepicker-1').length ) {
            FE.DatePicker.init();
            FE.DataProtectionFormLink.init();
        }
        if ( document.querySelector('[data-booking-id]') ) {
            FE.Booking.init();
        }

        if (document.querySelector('.page-info-bar')) {
            FE.PageInfoBar.init();
        }

        if (document.querySelector('.page-info-dialog')) {
            FE.PageInfoDialog.init();
        }


	});

}(jQuery, window, document));
